import React, { useState, useEffect } from "react";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";
import shopify from "../../../../../js/shopify";
import useCartData from "@arctheme-hooks/useCartData";

interface MinicartUpgradeProps {
  items: any[];
  settings: {
    upgrade_section_title?: string;
    upgrade_section_title_style?: string;
    upgrade_metafield_key?: string;
    upgrade_button_text?: string;
    upgrade_button_text_style?: string;
    product_title_style?: string;
    add_button_text?: string;
    add_button_text_style?: string;
    open_by_default?: any;
  };
  onAccordionToggle?: (isOpen: boolean) => void; // <- Correct type
}

export const MinicartUpgrade = ({ items, settings, onAccordionToggle }: MinicartUpgradeProps) => {
  const {cart, fetchCart}: any = useCartData();

  const [upgradeProducts, setUpgradeProducts] = useState([]);
  const [loading, setLoading] = useState(true);  
  const [isOpen, setIsOpen] = useState(settings?.open_by_default || false);

  const titleStyle = settings?.upgrade_section_title_style || 'h5';
  const sectionTitle = settings?.upgrade_section_title || 'Upgrade';
  const metafieldKey = 'product_bundle';
  const buttonText = settings?.upgrade_button_text || 'Upgrade & Save $29.95';
  const productTitleStyle = settings?.product_title_style || 'text-sm font-medium';
  const upgradeButtonTextStyle = settings?.upgrade_button_text_style || 'text-sm text-green-700';
  const addButtonText = settings?.add_button_text || 'Add';
  const addButtonTextStyle = settings?.add_button_text_style || 'text-sm font-medium';
  

  useEffect(() => {
    async function fetchUpgradeProducts() {
      try {
        setLoading(true);
        
        // Get any bulk buy metafields from the cart items
        let allProducts = [];

        
            // Process each cart item
            for (const item of items) {

              if (item.product?.metafields) {
                const bundleMetafield = item.product.metafields.find(
                  metafield => metafield.key === metafieldKey
                );
                if (bundleMetafield && bundleMetafield.value) {
                  try {
                    const metaobjectIds = Array.isArray(bundleMetafield.value) 
                      ? bundleMetafield.value 
                      : JSON.parse(bundleMetafield.value);
                    for (const metaobjectId of metaobjectIds) {
                      const metaobjectProducts = await shopify.getMetaobjectData(metaobjectId);
                      if (metaobjectProducts) {
                        const productsWithPrice = metaobjectProducts.map(product => ({
                          ...product,
                          originalCartItemPrice: item.price,
                          originalCartItemKey: item.key
                        }));
                        allProducts = [...allProducts, ...productsWithPrice];
                      }
                    }
                  } catch (e) {
                    console.error("Error processing metaobject:", e);
                  }
                }
              }
            }
        // Filter products that have a higher price than the original item
        const upgrades = allProducts.filter(product => {
          const productPrice = product.price || product.priceRange?.minVariantPrice?.amount;
          return productPrice > product.originalCartItemPrice;
        });

        setUpgradeProducts(upgrades);
     
      } catch (error) {
        console.error("Error fetching upgrade products:", error);
      } finally {
        setLoading(false);
      }
    }
    
    if (items?.length > 0) {
      fetchUpgradeProducts();
    }
  }, [items, metafieldKey]);

  const formatMoney = (cents) => {
    const dollars = cents / 100;
    return dollars.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  };



  
  const toggleAccordion = () => {
    setIsOpen(!isOpen);
    if (onAccordionToggle) {
      onAccordionToggle(!isOpen); // safe to call now
    }
  };
  
  if (upgradeProducts.length === 0) {

  }


  if (!upgradeProducts || upgradeProducts.length === 0) {
    return null;
  }
  
  
  return (
    <div className="minicart-upsells border-gray-200 pb-4 pt-[10px] px-2 rounded-xl">
      <div className={` accordion product-list minicart-recommendations flex flex-col ${!isOpen ? 'active' : ''}`}>
          <div className={"section-top"}>
            <div className={`section-bar mb-2 w-full flex flex-row justify-between items-center`}
            onClick={toggleAccordion}
            >
              <div className="accordion__header"
              >
              <Paragraph classes={`${titleStyle}`} text={sectionTitle} />
              </div>
              <span className="accordion__toggle">
              <i className={`icon font-bold text-[24px] ${isOpen ? 'icon-chevron-down' : 'icon-chevron-right'}`}></i>
              </span>
            </div>
          </div>
    
          <div className={`accordion-content ${isOpen ? "active pb-[10px]" : ""}`}
            style={{
              maxHeight: isOpen? "1000px" : "0",
              overflow: "hidden",
              transition: "max-height 0.3s ease-out"
            }} >
            <div className="row-start-1 col-start-1">
              <div className="list-products-default carousel-item-container w-full">
              <div 
              className="carousel w-full"
                  
                >
             {upgradeProducts.map((product, index) => (
                <div key={`${product.id}_${index}`} className="minicart-upsell-product mr-2 w-[280px] min-w-[280px] mb-2 p-2 bg-[#FFF9F5] rounded-xl flex items-center justify-between">
                  <div className="flex items-center">
                    <div className="h-[60px] w-[60px]">
                      <img 
                        src={product.featuredImage.src || product.images?.[0]?.src} 
                        alt={product.title} 
                        className="w-full h-full object-contain rounded"
                      />
                    </div>
                    <div className="ml-2 flex flex-col gap-2">
                      <Paragraph classes={productTitleStyle} text={product.title} />
                      <p className="b3"> {formatMoney(product.price)}</p>
                      <button 
                        className=" button button-secondary py-2 px-3 rounded-md"
                        onClick={async () => {
                          await fetch('/cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ id: product.originalCartItemKey, quantity: 0 })
                          });
                          await fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ id: product.variants?.[0]?.id, quantity: 1 })
                          });
                          document.dispatchEvent(new CustomEvent('liquid-ajax-cart:request-end'));
                        }}                      >
                      <Paragraph text={buttonText} />
                  </button>
                    </div>
                  </div>
                  
                
                </div>
              ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      
    </div>
  );
};